"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectAttributeFilterHandler = void 0;
var tslib_1 = require("tslib");
var loader_1 = require("./loader");
/**
 * @internal
 */
var MultiSelectAttributeFilterHandler = /** @class */ (function (_super) {
    tslib_1.__extends(MultiSelectAttributeFilterHandler, _super);
    function MultiSelectAttributeFilterHandler(config) {
        var _this = _super.call(this, config) || this;
        // manipulators
        _this.changeSelection = function (selection) {
            _this.bridge.changeMultiSelection(selection);
        };
        _this.revertSelection = function () {
            _this.bridge.revertMultiSelection();
        };
        _this.commitSelection = function () {
            _this.bridge.commitMultiSelection();
        };
        _this.invertSelection = function () {
            _this.bridge.invertMultiSelection();
        };
        _this.clearSelection = function () {
            _this.bridge.clearMultiSelection();
        };
        // selectors
        _this.getWorkingSelection = function () {
            return _this.bridge.getWorkingMultiSelection();
        };
        _this.isWorkingSelectionEmpty = function () {
            return _this.bridge.getIsWorkingSelectionEmpty();
        };
        _this.isWorkingSelectionChanged = function () {
            return _this.bridge.getIsWorkingSelectionChanged();
        };
        _this.getCommittedSelection = function () {
            return _this.bridge.getCommittedMultiSelection();
        };
        // callbacks
        _this.onSelectionChanged = function (cb) {
            return _this.bridge.onMultiSelectionChanged(cb);
        };
        _this.onSelectionCommitted = function (cb) {
            return _this.bridge.onMultiSelectionCommitted(cb);
        };
        return _this;
    }
    return MultiSelectAttributeFilterHandler;
}(loader_1.AttributeFilterLoader));
exports.MultiSelectAttributeFilterHandler = MultiSelectAttributeFilterHandler;
//# sourceMappingURL=multiSelectHandler.js.map